export const CANCEL_DIALOG = 'move-single-board-dialog/CANCEL_DIALOG';
export const INIT_DIALOG = 'move-single-board-dialog/INIT_DIALOG';
